import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  SUPERADMIN_ROUTES,
  ADMIN_ROUTES,
  USER_ROUTES,
  ADMIN_EVENT_ORDER,
  ADMIN_EVENT_REGIS
} from './sidebar-routes.config';
// import { RouteInfo } from './sidebar.metadata';
// import { Router, ActivatedRoute } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { UsersService } from '../services/users.service';

declare var $: any;
@Component({
  // moduleId: module.id,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements OnInit {
  public menuItems: any[];

  constructor(
    // private router: Router,
    // private route: ActivatedRoute,
    private angularFireAuth: AngularFireAuth,
    private usersService: UsersService
  ) {
    // console.log('sidebar');
    this.usersService.get(this.angularFireAuth.auth.currentUser.uid).subscribe((res: any) => {
      console.log(res); // Not Show in production
      if (res.type === 'superadmin') {
        this.menuItems = SUPERADMIN_ROUTES.filter(menuItem => menuItem);
      } else if (res.type === 'admin' && res.eventId && res.eventType === 'shirt') {
        this.menuItems = ADMIN_EVENT_ORDER.filter(menuItem => menuItem);
      } else if (res.type === 'admin' && res.eventId && res.eventType === 'run') {
        this.menuItems = ADMIN_EVENT_REGIS.filter(menuItem => menuItem);
      } else if (res.type === 'admin') {
        this.menuItems = ADMIN_ROUTES.filter(menuItem => menuItem);
      } else {
        this.menuItems = USER_ROUTES.filter(menuItem => menuItem);
      }
    });
  }

  ngOnInit() {
    $.getScript('./assets/js/app-sidebar.js');

    // console.log(this.angularFireAuth.auth.currentUser);
    // this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
}
